import "core-js/modules/es.number.constructor";
import "core-js/modules/es.object.define-property";
import "core-js/modules/es.object.to-string";
import { __awaiter, __decorate, __extends, __generator } from "tslib";
import { Vue, Component, Watch } from 'vue-property-decorator';

var FaqListPage = function (_super) {
  __extends(FaqListPage, _super);

  function FaqListPage() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.cateId = undefined;
    _this.isPending = false;
    _this.problemList = [];
    _this.page = 1;
    _this.pageSize = 10;
    _this.total = 0;
    return _this;
  }

  Object.defineProperty(FaqListPage.prototype, "routeParams", {
    get: function get() {
      return this.$route.params;
    },
    enumerable: false,
    configurable: true
  });

  FaqListPage.prototype.created = function () {
    this.cateId = this.$route.query.cate_id ? Number(this.$route.query.cate_id) : undefined;

    if (this.cateId) {
      this.queryProblemList();
    }
  };

  FaqListPage.prototype.onQueryCateIdChange = function (cateId) {
    this.cateId = cateId ? Number(cateId) : undefined;
    this.initPage();

    if (this.cateId) {
      this.queryProblemList();
    }
  };

  FaqListPage.prototype.onQueryChannelChange = function (channel) {
    var newChannel = channel ? Number(channel) : undefined;
    this.channel = newChannel;
  };

  FaqListPage.prototype.queryProblemList = function () {
    return __awaiter(this, void 0, Promise, function () {
      var queryData, data;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            this.isPending = true;
            queryData = {
              cate_id: this.cateId,
              channel: this.channel,
              page_size: this.pageSize,
              page_index: this.page
            };
            return [4, this.$api.helpCenter.queryProblemList(queryData)];

          case 1:
            data = _a.sent().data;
            this.isPending = false;
            this.problemList = data.data;
            this.total = data.total;
            return [2];
        }
      });
    });
  };

  FaqListPage.prototype.handlePageChange = function (val) {
    this.page = val;
    this.queryProblemList();
  };

  FaqListPage.prototype.initPage = function () {
    this.problemList = [];
    this.page = 1;
    this.total = 0;
  };

  __decorate([Watch('$route.query.cate_id')], FaqListPage.prototype, "onQueryCateIdChange", null);

  __decorate([Watch('$route.query.channel', {
    immediate: true
  })], FaqListPage.prototype, "onQueryChannelChange", null);

  FaqListPage = __decorate([Component], FaqListPage);
  return FaqListPage;
}(Vue);

export default FaqListPage;